import styled from "styled-components";

export const Container = styled.div`
  width: 100vw;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.main`
  width: 1320px;
  padding: 0px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
